import apiClient from './apiClient';

// Request to list eventVendors
export const listEventVendorsRequest = (data) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/events',
    data
  });

// Request to search eventVendors
export const searchEventVendorsRequest = (query) =>
  apiClient({
    method: 'GET',
    url: '/event-booking/events',
    params: { query },
  });

// Request to filter eventVendors
export const filterEventVendorsRequest = (filters) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/events',
    data: filters,
  });

// Request to export eventVendors
export const exportEventVendorsRequest = (format) =>
  apiClient({
    method: 'GET',
    url: `/event/vendors/export`,
    params: { format },
  });

// Request to get provider info
export const getEventVendorInfoRequest = (id) =>
  apiClient({
    method: 'GET',
    url: `/event/vendors/${id}`,
  });

// Request to update provider info
export const updateEventVendorInfoRequest = (data) => {
  const {id, ...payload} = data || {}; // Ensure id is not included in the data payload
  return apiClient({
    method: 'PUT',
    url: `/event-booking/vendors/${id}`,
    data: payload,
  });
}

// Request to add a provider
export const addEventVendorRequest = (data) =>
  apiClient({
    method: 'POST',
    url: '/event-booking/vendors/add',
    data,
  });


// Request to download attendees for a specific event
export const downloadAttendeesRequest = (eventId, format = 'csv') =>
  apiClient({
    method: 'GET',
    url: `/event-booking/events/${eventId}/attendees/download`,
    params: { format },
    responseType: 'blob', // ensures file is downloaded correctly
  });

// Request to stop a specific event
export const stopEventRequest = (eventId) =>
  apiClient({
    method: 'POST',
    url: `/event-booking/events/${eventId}/stop`,
  });


